import { render, staticRenderFns } from "./VDesignRequestReturnToReworkModal.vue?vue&type=template&id=3b87a390&"
import script from "./VDesignRequestReturnToReworkModal.vue?vue&type=script&lang=ts&"
export * from "./VDesignRequestReturnToReworkModal.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignRequestReturnToReworkModal.vue?vue&type=style&index=0&id=3b87a390&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports